function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var hasOwn = {}.hasOwnProperty;
export var scopeClassName = function scopeClassName(Component) {
  return function (className) {
    var _ref = Component.classNames || {},
        _ref$base = _ref.base,
        base = _ref$base === void 0 ? {} : _ref$base,
        _ref$target = _ref.target,
        target = _ref$target === void 0 ? {} : _ref$target;

    return className.split(/\s+/).map(function (x) {
      return base[x] || target[x] || x;
    }).join(' ');
  };
};
export default function classNames() {
  var classes = [];

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  args.forEach(function (arg) {
    if (!arg) return;

    var argType = _typeof(arg);

    if (argType === 'string' || argType === 'number') {
      classes.push(arg);
    } else if (Array.isArray(arg) && arg.length) {
      var inner = classNames.apply(void 0, _toConsumableArray(arg));

      if (inner) {
        classes.push(inner);
      }
    } else if (argType === 'object') {
      Object.keys(arg).forEach(function (key) {
        if (hasOwn.call(arg, key) && arg[key]) {
          classes.push(key);
        }
      });
    }
  });
  return classes.join(' ');
}
export var classNamesFor = function classNamesFor(Component) {
  return function () {
    return scopeClassName(Component)(classNames.apply(void 0, arguments));
  };
};